import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faExclamationCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

export const ResponseSuccessModal = ({
  isOpen,
  toggle,
  message,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={isOpen}
      onHide={() => toggle()}
      centered
      size='sm'
    >
      <ModalBody className='text-center m-3'>
        <FontAwesomeIcon icon={faCheckCircle} style={{fontSize:'5em', color:'#28a745'}}/>
        <p className='mb-0 mt-4' style={{fontSize:'15px'}}>
          {message}
        </p>
        <button className='modal-btn-close' onClick={() => toggle()}>
          <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/>{t('button.close')}
        </button>
      </ModalBody>
    </Modal>
  );
}

export const ResponseFailModal = ({
  isOpen,
  toggle,
  message,
  subMessage,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={isOpen}
      onHide={() => toggle()}
      centered
      size='sm'
    >
      <ModalBody className='text-center m-3'>
        <FontAwesomeIcon icon={faExclamationCircle} className='response-fail'/>
        <p className='response-fail-msg'>
          {message}
        </p>
        <p className='response-fail-sub-msg' hidden={!subMessage}>
          {subMessage}
        </p>
        <button className='modal-btn-close' onClick={() => toggle()}>
          <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/>{t('button.close')}
        </button>
      </ModalBody>
    </Modal>
  );
}
